import { Badge } from "@/components/ui/badge"

export default function StudyMoveActivityStep() {
  return (
    <section className="flex flex-col gap-4">
      <header className="flex items-center gap-2">
        <h1 className="text-base font-bold">Mover una actividad a otro día</h1>
      </header>
      <img
        className="w-full object-contain"
        src="https://storage.googleapis.com/educabot-aec-cdn-1/tuni/product-tour/study-move-activity.gif"
      />
      <p className="text-left text-sm text-muted-foreground">
        Mové las actividades al día que mejor se adapte a vos. Si te pasás del tiempo de estudio
        disponible, te vamos a avisar para que puedas reorganizarte y seguir con todo. ¡Vos tenés el
        control!
      </p>
      <Badge className="-mb-12 w-fit bg-primary-50 text-primary-500">
        <span className="font-semibold">Paso 5 de 8</span>
      </Badge>
    </section>
  )
}
